import React, { forwardRef } from 'react';
import cn from 'classnames';
import BaseButton from './BaseButton';

const DeleteButton = forwardRef(({ title = 'Delete', className, ...props }, ref) => {
  const btnClassName = cn('delete-button', { [className]: className });
  return (
    <BaseButton
      ref={ref}
      id='delete-button'
      fillMode='outline'
      themeColor={props.disabled ? 'secondary' : 'error'}
      className={btnClassName}
      icon='delete'
      title={title}
      tooltip={title}
      {...props}
    />
  );
});

export default DeleteButton;
